@switch (redirectToExternalBankPage) {
  @case ('REDIRECT_TO_EXTERNAL_BANK_WAIT') {
    <app-redirect-to-external-bank-wait [selectedBank]="selectedBank"></app-redirect-to-external-bank-wait>
  }
  @case ('REDIRECT_TO_EXTERNAL_BANK_ERROR') {
    <app-redirect-to-external-bank-error></app-redirect-to-external-bank-error>
  }
}
